/* eslint-disable import/prefer-default-export */

export const APP_STORE_LINK = 'https://apps.apple.com/app/sugarless-quit-sugar-habit/id1578163612';
